import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Currency, Lesson, Pupil } from '@df/interfaces';

@Component({
    selector: 'app-stat-lesson-pupil',
    templateUrl: './stat-lesson-pupil.component.html',
    styleUrls: ['./stat-lesson-pupil.component.scss']
})
export class StatLessonPupilComponent implements OnChanges {
    @Input() pupil: Pupil;
    @Input() lesson: Lesson;
    @Input() individual_data: any;
    @Input() currency: Currency;

    avg_resolve_speed: number;
    avg_amount_speed: number;

    constructor() {}

    public ngOnChanges(_changes: SimpleChanges): void {
        if (this.individual_data) {
            if (this.individual_data.student_amount_stat) {
                this.avg_amount_speed = this.individual_data.student_amount_stat.individual_avg_currencies_amount_speed.toFixed(
                    2
                );
            } else {
                this.avg_amount_speed = 0;
            }

            if (this.individual_data.student_stat_for_lesson) {
                this.avg_resolve_speed = this.individual_data.student_stat_for_lesson.individual_avg_resolve_speed.toFixed(
                    2
                );
            }
        }
    }
}
